import { TOGGLE_SIDEBAR } from "../types/type";

const initialState = {
    activeMenuTabs: null,
};

const sidebarReducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                activeMenuTabs: {...payload},
            };
        default:
            return state;
    }
};

export default sidebarReducer;
